// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyHome: LoadableType<{}> = LoadablePaint({
	loader: async () => (await import(/* webpackChunkName: "loadable-Home" */ './Home.tsx')).Home,
});

export { View, SUPPORTED_ROUTES } from './homeRouteParams.ts';

export { LoadingDone } from './RightPanel/LoadingListener/LoadingDone.tsx';

export { RIGHT_PANEL_COMPACT_CLASS } from './RightPanel/useRightPanelResize.ts';

export { RightPanel } from './RightPanel/RightPanel.tsx';
